module.exports = __webpack_public_path__ + "img/greensuitman2.7c640e50.jpg";